module.exports = __webpack_public_path__ + "img/banner1.4d4187af.jpg";